module.exports = __webpack_public_path__ + "assets/img/es.af338a30.png";